const REASON_COPY: Record<string, string> = {
  non_2xx: 'the endpoint returned an error response',
  network_error: "couldn't reach the endpoint",
  payload_too_large: 'the payload was too large to send',
  non_https: "the destination URL isn't secure (HTTPS)",
  ssrf: "the destination address isn't allowed",
  config_error: 'the endpoint is misconfigured',
  invalid_auth_method: "the authentication method isn't valid",
  no_secret: 'no signing secret is set',
  exhausted: 'all retries were used up',
  internal_error: 'an internal error occurred',
  disabled: 'the endpoint is turned off',
  missing_destination_url: 'no destination URL is set',
  org_deactivated: 'the workspace is deactivated',
};

// Maps a DeliveryReason slug to human-readable copy. Returns undefined for
// success (2xx), unknown slugs, and absent/blank input so callers can render
// a generic fallback without leaking internal slug names.
export function webhookOutcomeReason(
  lastError?: string | null
): string | undefined {
  if (!lastError || !lastError.trim() || lastError === '2xx') {
    return undefined;
  }
  return REASON_COPY[lastError];
}
